module.exports = __webpack_public_path__ + "img/sablier2.5965ff1c.svg";